export default __webpack_public_path__ + "static/media/T22.f2e49ce1.JPG";